import type { Chart, LegendItem } from 'chart.js';
import { Chart as ChartJS } from 'chart.js';

/**
 * Chart.js legend: match each entry's stroke to the dataset's borderDash (dashed BAU vs solid scenario).
 * Uses datasetIndex so order stays correct after default generateLabels.
 */
export function legendLabelsReflectLineDash(this: unknown, chart: Chart): LegendItem[] {
  const gen = ChartJS.defaults.plugins.legend.labels.generateLabels;
  const labels = gen.call(this, chart) as LegendItem[];
  labels.forEach((label) => {
    const idx = label.datasetIndex;
    if (idx === undefined || idx < 0) return;
    const dataset = chart.data.datasets[idx] as {
      borderDash?: number[];
      borderColor?: string | string[];
    };
    if (!dataset) return;
    const dash = dataset.borderDash;
    label.lineDash = Array.isArray(dash) && dash.length > 0 ? [...dash] : [];
    const bc = dataset.borderColor;
    if (typeof bc === 'string' && bc !== 'transparent') {
      label.strokeStyle = bc;
      label.fillStyle = bc;
    }
  });
  return labels;
}
